export const handleCFCSolutions = (enabledServices) => {
    if (enabledServices.cfc && enabledServices.cfc !== "#") {
        return enabledServices;
    }
    const [, cfcUrl] = Object.entries(enabledServices).find(([key, url]) => key.startsWith("cfc.ccf-") && url !== "#") ?? [];
    if (!cfcUrl) {
        return {
            ...enabledServices,
            cfc: "#",
        };
    }
    return {
        ...enabledServices,
        cfc: cfcUrl,
    };
};
export const handleCalculationSolutions = (enabledServices) => {
    const { fpc, cfc } = enabledServices;
    if (fpc && !cfc) {
        delete enabledServices.fpc;
        return {
            ...enabledServices,
            cfc: fpc,
        };
    }
    delete enabledServices.fpc;
    return {
        ...enabledServices,
        cfc: cfc === "#" ? fpc : cfc,
    };
};
export const servicesMapping = {
    "network-purchaser": "network",
    "network-supplier": "network",
};
export const handleNetworkServices = (enabledServices) => Object.entries(enabledServices).reduce((acc, service) => {
    const [serviceId, url] = service;
    const mappedServiceId = servicesMapping[serviceId] ?? serviceId;
    if (!acc[mappedServiceId] || url !== "#") {
        acc[mappedServiceId] = url;
    }
    return acc;
}, {});
export const mapServiceUrlsByAccess = (serviceUrls) => {
    const services = Object.fromEntries(serviceUrls.map(({ id, url, userHasAccess }) => [id, userHasAccess ? url : "#"]));
    const cfcProcessedServices = handleCFCSolutions(services);
    const fpcProcessedServices = handleCalculationSolutions(cfcProcessedServices);
    const networkProcessedServices = handleNetworkServices(fpcProcessedServices);
    return networkProcessedServices;
};
//# sourceMappingURL=mapServiceUrlsByAccess.js.map